<p
  class="job-services"
  [class.inline-view]="isInlineView"
>
  <ion-icon
    name="calendar"
    slot="start"
  ></ion-icon>
  <ion-label *ngIf="formattedJobData as job">
    <ng-container *ngIf="isInlineView; else summaryView">
      <p>
        <span>
          {{ job.frequency }} · {{ job.hours
          }}<ng-container *ngIf="!job.isOneOffJob && job.sessions">, {{ job.sessions }} </ng-container>
          <ng-container *ngIf="!job.isOneOffJob">· {{ job.jobStartDetail }} </ng-container>
        </span>
      </p>
    </ng-container>

    <ng-template #summaryView>
      <ng-container *ngIf="job.isOneOffJob; else frequency">
        <p>{{ job.frequency }}</p>
        <p>{{ job.hours }}</p>
      </ng-container>
      <ng-template #frequency>
        <p>{{ job.frequency }}</p>
        <p>{{ job.hours }}, {{ job.sessions }}</p>
        <p>{{ job.jobStartDetail }}</p>
      </ng-template>
    </ng-template>
  </ion-label>
</p>
